"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const _1 = require(".");
function default_1() {
    const uid = (0, react_redux_1.useSelector)((state) => state.roomData.uid);
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const profileImg = (0, react_redux_1.useSelector)((state) => state.roomData.leader_profile_img_url);
    const leaderNick = (0, react_redux_1.useSelector)((state) => state.roomData.leader_nick);
    const notice = (0, react_redux_1.useSelector)((state) => state.roomData.notice);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '10px',
            padding: '14px 20px 16px',
            borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
            marginBottom: '10px',
            backgroundColor: 'white',
        } }, { children: [(0, jsx_runtime_1.jsxs)("a", Object.assign({ className: "no_anchor_deco", href: `/@${uid}`, onClick: e => isPreview && e.preventDefault(), css: {
                    display: 'inline-flex',
                    alignSelf: 'flex-start',
                    alignItems: 'center',
                    columnGap: '8px',
                } }, { children: [(0, jsx_runtime_1.jsx)(components_1.RoundImage, { size: 32, src: profileImg, altSrc: `${process.env.CDN_URL}/assets/svgs/default_profile.svg` }), (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.8)' } }, { children: leaderNick })), (0, jsx_runtime_1.jsx)(svgs_1.ChevronOvalRightSvg, { css: { width: '16px', height: '16px' } })] })), notice && (0, jsx_runtime_1.jsx)("div", Object.assign({ css: { fontSize: '14px', lineHeight: ' 21px' } }, { children: notice })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(_1.LeaderInfoSubscribeButton, { isPreview: isPreview }), (0, jsx_runtime_1.jsx)(_1.LikeButton, { isPreview: isPreview })] }))] })));
}
exports.default = default_1;
